
<template>
  <a-menu style="width:200px;margin-top:80px;" mode="vertical" @click="handleClick">
    <a-menu-item key="home" style="border-bottom:1px dashed #dcdcdc;">下单</a-menu-item>
    <a-menu-item key="order">订单列表</a-menu-item>
  </a-menu>
</template>
<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {};
  },
  methods: {
    ...mapActions(["setSideOpen"]),
    handleClick(e) {
      console.log("click:", e);
      this.$router.push({ name: e.key });
      this.setSideOpen(false);
    }
  }
};
</script>